interface Props {
    isFileUploaded: boolean;
    inputId: string;
    buttonIconTitle: string;
    buttonTitle: string;
    labelTitle: string;
    labelIconTitle: string;
    showText: boolean;
    bgButtonColor: string;
    bgLabelColor: string;
    title?: string;
    titleRemove?: string;
    handlerResetProgramation: (inputId: string) => void;
    isImage?: boolean;
    sourceImg?: string;
}

export default function UploadFileButton({
    isFileUploaded,
    inputId,
    buttonIconTitle,
    buttonTitle,
    labelTitle,
    labelIconTitle,
    showText,
    bgButtonColor,
    bgLabelColor,
    title,
    titleRemove,
    isImage,
    sourceImg,
    handlerResetProgramation,
}: Props) {
    return (
        <>
            {isFileUploaded ? (
                isImage ? (
                    <button
                        title={titleRemove}
                        onClick={(e) => handlerResetProgramation(inputId)}
                        className={`btn d-flex align-items-center justify-content-center gap-1 ${bgButtonColor}`}
                    >
                        <img src={sourceImg} alt='imagen' style={{ width: 20 }} />
                    </button>
                ) : (
                    <button
                        className={`btn d-flex align-items-center justify-content-center gap-1 ${bgButtonColor}`}
                        style={{ height: 40 }}
                        onClick={(e) => handlerResetProgramation(inputId)}
                        title={titleRemove}
                    >
                        <i className={buttonIconTitle} style={{ fontSize: 18 }}></i>
                        {showText && <span>{buttonTitle}</span>}
                    </button>
                )
            ) : (
                <label
                    title={title}
                    htmlFor={inputId}
                    className={`btn d-flex align-items-center justify-content-center m-0 ${bgLabelColor}`}
                    style={{ height: 40 }}
                >
                    <i className={labelIconTitle}></i>
                    {showText && <span className=''>{labelTitle}</span>}
                </label>
            )}
        </>
    );
}
